import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import List from '@material-ui/core/List';
import Button from '@material-ui/core/Button';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';
import CircularProgress from '@material-ui/core/CircularProgress';

import toCurrency from '../util/toCurrency.js'


const styles = theme => ({
  listItem: {
    padding: `${theme.spacing.unit}px 0`,
  },
  totalLabel: {
    fontWeight: '700',
  },
  totalPrice: {
    textAlign: 'right',
    fontWeight: '700',
  },
  title: {
    marginTop: theme.spacing.unit * 2,
  },
  placeOrderButton: {
    float: 'right',
    marginTop: theme.spacing.unit * 3,
    marginLeft: theme.spacing.unit,
  },
});


class Payment extends React.Component {


  handleSubmit = e => {
    const {actions} = this.props

    this.setState({ showErrors: false })
    // Slight delay so form can submit
    setTimeout(actions.switchToProcessingStatus, 1)
  }


  render = () => {
    const { classes, data, actions } = this.props;
    const { pricing, canOrderWithoutPayment } = data

    const {
      activationFees,
      licenseFees,
      shippingFees,
      activationFeeTotal,
      licenseFeeTotal,
      shippingFeeTotal,
      activationFeeTax,
      licenseFeeTax,
      shippingFeeTax,
      recalculating,
    } = pricing


    if (recalculating) {
      return (
        <div style={{display:'flex', alignItems: 'center', justifyContent: 'center', margin: '200px auto'}}>
          <CircularProgress className={classes.progress} style={{marginRight: 20}}/>
          <Typography variant="h6" component="div">
            Calculating...
          </Typography>
        </div>
      )
    }


    if (canOrderWithoutPayment) {
      return (
        <React.Fragment>
          <Typography variant="h6" gutterBottom>
            All set.
          </Typography>
          <Typography variant="body2" gutterBottom>
            Nothing to pay today. Just tap the Place Order button.
          </Typography>
        </React.Fragment>
      )
    }


    return (
      <React.Fragment>

        {
          shippingFees.length
          ?
            <React.Fragment>
              <Typography variant="h6" gutterBottom>
                Shipping Fee (Estimated)
              </Typography>
              <List disablePadding>
                {shippingFees.map(item => (
                  <ListItem key={item.name} className={classes.listItem}>
                    <ListItemText primary={item.name} secondary={item.detail} />
                    <Typography variant="body2">{toCurrency(item.price)}</Typography>
                  </ListItem>
                ))}
                {
                  shippingFeeTax
                  ?
                    <ListItem className={classes.listItem}>
                      <ListItemText primary="Taxes" />
                      <Typography variant="body2">{toCurrency(shippingFeeTax)}</Typography>
                    </ListItem>
                  :
                    null
                }
                <ListItem className={classes.listItem}>
                  <ListItemText primary={<Typography variant="subtitle1" className={classes.totalLabel}>Total</Typography>}/>
                  <Typography variant="subtitle1" className={classes.totalPrice}>
                    {toCurrency(shippingFeeTotal)}
                    <br/>
                    <Typography variant="caption" gutterBottom>
                      Paid when your books ship
                    </Typography>
                  </Typography>
                </ListItem>
              </List>

              <br/>
              <Divider variant="middle" />
              <br/>
            </React.Fragment>
          :
            null
        }

        { licenseFees.length
          ? <React.Fragment>
              <Typography variant="h6" gutterBottom>
                Monthly License Fee
              </Typography>
              <List disablePadding>
                {licenseFees.map(item => (
                  <ListItem key={item.name} className={classes.listItem}>
                    <ListItemText primary={item.name} secondary={item.detail} />
                    <Typography variant="body2">{toCurrency(item.price)}</Typography>
                  </ListItem>
                ))}
                {
                  licenseFeeTax
                  ?
                    <ListItem className={classes.listItem}>
                      <ListItemText primary="Taxes" />
                      <Typography variant="body2">{toCurrency(licenseFeeTax)}</Typography>
                    </ListItem>
                  :
                    null
                }
                <ListItem className={classes.listItem}>
                  <ListItemText primary={<Typography variant="subtitle1" className={classes.totalLabel}>Total</Typography>}/>
                  <Typography variant="subtitle1" className={classes.totalPrice}>
                    {toCurrency(licenseFeeTotal)}
                      <br/>
                    <Typography variant="caption" gutterBottom>
                      You'll pay this each month
                    </Typography>
                  </Typography>
                </ListItem>
              </List>

              <br/>
              <Divider variant="middle" />
              <br/>
            </React.Fragment>
          : null
        }

        {
          activationFees.length
          ?
            <React.Fragment>
              <Typography variant="h6" gutterBottom>
                Activation Fee
              </Typography>
              <List disablePadding>
                {activationFees.map(item => (
                  <ListItem key={item.name} className={classes.listItem}>
                    <ListItemText primary={item.name} secondary={item.detail} />
                    <Typography variant="body2">{toCurrency(item.price)}</Typography>
                  </ListItem>
                ))}
                {
                  activationFeeTax
                  ?
                    <ListItem className={classes.listItem}>
                      <ListItemText primary="Taxes" />
                      <Typography variant="body2">{toCurrency(activationFeeTax)}</Typography>
                    </ListItem>
                  :
                    null
                }
                <ListItem className={classes.listItem}>
                  <ListItemText primary={<Typography variant="subtitle1" className={classes.totalLabel}>Total</Typography>}/>
                  <Typography variant="subtitle1" className={classes.totalPrice}>
                    {toCurrency(activationFeeTotal)}
                    <br/>
                    <Typography variant="caption" gutterBottom>
                      You'll pay this today
                    </Typography>
                  </Typography>
                </ListItem>
              </List>

              <br/>
              <Divider variant="middle" />
              <br/>
            </React.Fragment>
          :
            null
        }

        {
          !canOrderWithoutPayment
          ? <React.Fragment>

              <Typography variant="h6" gutterBottom>
                Payment
              </Typography>

              <br/>

              <Typography variant="body2">
                Thank you for signing up for FieldEdge FlatRate powered by CoolFront. You will receive an email soon from billing@fieldedge.com with a secure link to process payment for your set-up fees and to save your credit card information for your monthly service fee.
              </Typography>

              <Typography variant="body1">
                <Button onClick={actions.placeOrder} variant="contained" color="primary" className={classes.placeOrderButton}>Place Order</Button>
              </Typography>

            </React.Fragment>
          : null
        }

      </React.Fragment>
    )
  }

}

Payment.propTypes = {
  classes: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
};

export default withStyles(styles)(Payment);